import { SVGProps } from "react";

const Whatsapp = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    width={props?.width ? props.width : 24}
    height={props?.height ? props.height : 24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      d="M15.5836 15.125C13.9886 16.72 10.3137 15.3606 8.47672 13.5236C6.63972 11.6866 5.2803 8.01167 6.8753 6.41667C7.3373 5.95467 7.97347 5.89967 8.36213 5.91801C8.58672 5.92809 8.78105 6.06009 8.91213 6.24342L9.7848 7.46626C9.9108 7.64284 9.97008 7.85838 9.95212 8.07456C9.93417 8.29074 9.84012 8.49355 9.68672 8.64692L8.8608 9.47284C9.01297 9.93117 9.50247 11.0312 10.2358 11.7645C10.9691 12.4978 12.0691 12.9873 12.5275 13.1395L13.3534 12.3145C13.5066 12.161 13.7094 12.0668 13.9256 12.0486C14.1418 12.0305 14.3574 12.0896 14.5341 12.2155L15.7569 13.0882C15.9402 13.2193 16.0722 13.4136 16.0823 13.6382C16.1006 14.0268 16.0456 14.663 15.5836 15.125Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M11 20.625C16.3158 20.625 20.625 16.3157 20.625 11C20.625 5.68425 16.3158 1.375 11 1.375C5.68425 1.375 1.375 5.68425 1.375 11C1.375 12.7527 1.84342 14.3972 2.66292 15.8125L1.85625 20.1437L6.1875 19.3371C7.65004 20.1832 9.31033 20.6276 11 20.625Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);

export default Whatsapp;
